module.exports = __webpack_public_path__ + "static/media/roboto-regular.60fa3c06.woff";